export abstract class LocationEx {
  public static get protocol(): string {
    return window.location.protocol;
  }
}
